import { Button } from 'react-aria-components';
import { msg } from '@gonfalon/messages/msg';
import { Icon } from '@launchpad-ui/icons';
import clsx from 'clsx';

import styles from './DataTableTreeGutter.module.css';

type Props = {
  level: number;
  ancestorLines: boolean[];
  hasChildren: boolean;
  isExpanded: boolean;
  isLastChild: boolean;
  label: string;
  onToggle: () => void;
};

export function DataTableTreeGutter({
  level,
  ancestorLines,
  hasChildren,
  isExpanded,
  isLastChild,
  label,
  onToggle,
}: Props) {
  const guideLines = ancestorLines.slice(0, -1);

  return (
    <div className={styles.gutter}>
      <span aria-hidden className={styles.indent} />

      {guideLines.map((isContinued, index) => (
        <span key={index} aria-hidden className={clsx(styles.level, { [styles.guideLine]: isContinued })} />
      ))}

      {level > 0 && (
        <span aria-hidden className={styles.connector}>
          <span className={clsx(styles.connectorSegment, styles.guideLine)} />
          <span className={styles.connectorElbow} />
          <span className={clsx(styles.connectorSegment, { [styles.guideLine]: !isLastChild })} />
        </span>
      )}

      <span className={styles.terminal}>
        {hasChildren ? (
          <>
            <span aria-hidden className={styles.terminalSpacer} />
            <Button
              className={styles.disclosureButton}
              aria-label={
                isExpanded
                  ? msg('ui.dataTable.tree.collapseLabel', { label })
                  : msg('ui.dataTable.tree.expandLabel', { label })
              }
              aria-expanded={isExpanded}
              onPress={onToggle}
            >
              <Icon name={isExpanded ? 'chevron-down' : 'chevron-right'} size="small" variant="subtle" />
            </Button>
            <span aria-hidden className={clsx(styles.terminalSpacer, { [styles.guideLine]: isExpanded })} />
          </>
        ) : (
          level > 0 && <span aria-hidden className={styles.leafDot} />
        )}
      </span>
    </div>
  );
}
